import type { ShopSpecial } from '../../services/shop-service';

// Weekly specials on the shop card — pull advertising (037). Expired
// specials never render (valid_until filter, no cron needed); a special
// carrying bonus_stamps advertises the game loop right on the card.

export default function ShopSpecials({ specials }: { specials?: ShopSpecial[] | null }) {
  const now = Date.now();
  const active = (specials || []).filter(
    (s) => s?.title && (!s.valid_until || new Date(s.valid_until).getTime() > now),
  );
  if (active.length === 0) return null;

  return (
    // 2px ink trim via an ink-filled wrapper - `pixel-corners` is a clip-path,
    // so a CSS border would be sliced off at every step.
    <div className="w-full pixel-corners bg-primary p-[2px]">
    {/* Teal, not gold: coral now consistently means "redeemed" across the app
        (the stats chart uses it for the redemption series), so specials take
        the teal accent instead. teal-ink keeps contrast on the cyan fill. */}
    {/* One LINE per special, not one paragraph (Nik, 2026-08-12: "put the
        muffins - 20 off" on one line, "pull the bonus stamp up to the top").
        Title, detail and bonus used to stack into three rows, so a single
        special cost ~110px of a screen that was already overflowing its mug
        station. Title and detail now share a row separated by a dot, and the
        bonus rides the same row as a chip pinned right — it keeps its own
        visual weight without spending a row on "when you buy it", which the
        chip's presence next to the offer already implies. Wraps to a second
        row only when the title is long enough to need it. */}
    <div className="bg-pixel-cyan pixel-corners px-[12px] py-[10px]">
      <p className="font-heading text-[8px] text-teal-ink tracking-[1px] mb-1.5">THIS WEEK'S SPECIALS</p>
      <ul className="space-y-1.5">
        {active.map((s) => (
          <li key={s.id} className="flex items-baseline justify-between gap-2">
            <p className="font-grotesk text-[14px] leading-tight min-w-0">
              <span className="font-bold text-primary">{s.title}</span>
              {s.detail && <span className="font-medium text-teal-ink"> · {s.detail}</span>}
            </p>
            {(s.bonus_stamps || 0) > 0 && (
              <span className="shrink-0 font-heading text-[8px] text-teal-ink bg-white/45 pixel-corners-sm px-[6px] py-[3px]">
                +{s.bonus_stamps} STAMP{(s.bonus_stamps || 0) > 1 ? 'S' : ''}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
    </div>
  );
}
